import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../Enums/Tranlate";

function ResetPasswordModal(props) {
	const [loading, setLoading] = useState(false);
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	const handleResetPassword = async () => {
		if (!password?.trim()) {
			return toast.error(Translate[lang]?.field_required);
		}
		setLoading(true);
		try {
			const res = await props.modelService.update(props.item.id, {
				password,
			});
			if (res?.status === 200 || res?.data?.statusCode === 200) {
				toast.success(Translate[lang]?.updated_successfully);
				props.onCloseModal(false);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			show={props.open}
			onHide={() => props.onCloseModal(false)}
			className={`${lang}`}>
			<div className="modal-header border-0">
				<h5 className="modal-title mt-0" id="myModalLabel">
					<i className="la la-key text-primary" style={{ fontSize: "20px" }}></i>{" "}
					{Translate[lang]?.reset_password} {props.titleMsg}
				</h5>
				<button
					type="button"
					onClick={() => props.onCloseModal(false)}
					className="close"
					data-dismiss="modal"
					aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div className="modal-body border-0">
				<label className="form-label">{Translate[lang]?.new_password}</label>
				<div className="position-relative">
					<input
						type={showPassword ? "text" : "password"}
						className="form-control"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder={Translate[lang]?.password}
					/>
					<i
						className={`la ${showPassword ? "la-eye-slash" : "la-eye"}`}
						onClick={() => setShowPassword((prev) => !prev)}
						title={
							showPassword
								? Translate[lang]?.hide_password
								: Translate[lang]?.show_password
						}
						style={{
							position: "absolute",
							top: "50%",
							transform: "translateY(-50%)",
							[lang === "ar" ? "left" : "right"]: "12px",
							cursor: "pointer",
							fontSize: "18px",
						}}
					/>
				</div>
			</div>
			<div className="modal-footer border-0">
				<button
					type="button"
					onClick={() => props.onCloseModal(false)}
					className="btn me-auto btn-secondary waves-effect waves-light"
					data-dismiss="modal">
					{Translate[lang]?.cancel}
				</button>
				<button
					onClick={handleResetPassword}
					type="button"
					className="btn btn-primary waves-effect"
					disabled={loading ? true : false}>
					{Translate[lang]?.send}
				</button>
			</div>
		</Modal>
	);
}

ResetPasswordModal.propTypes = {
	open: PropTypes.bool,
	onCloseModal: PropTypes.func,
	item: PropTypes.object,
	modelService: PropTypes.object,
	titleMsg: PropTypes.string,
};

export default ResetPasswordModal;
